import React from 'react';
import { useSelector } from 'react-redux';
import { CloseHoc, SearchHoc } from '../../assets/images';
import CustomIcon from '../../assets/images/CustomIcon';
import { getValidSearchVal } from '../../Helpers/Utility';
import { getUsersListFromSDK }from './RecentChatSection/userLists';

const WebChatSearch = (props = {}) => {
  const { handleSearchFilterList = () => {} } = props;
  const globalState = useSelector(state => state)
  const { mf_Search, mf_Close }=globalState?.dynamicIcon?.data

  /**
   * Following the states used in WebChatSearch Component.
   *
   */
  const [isTyping, setIsTyping] = React.useState(false);
  /**
  * Following the states used in WebChatSearch Component.
  *
  * @param {object} event to handle the searched element.
  */
  const searchFilterList = (search) => {
    const value = search.length > 0 ? search : '';
    const searchWith = getValidSearchVal(value);
    setIsTyping(value ? true : false)
    handleSearchFilterList(searchWith)
    getUsersListFromSDK(1, searchWith)
  }

  /**
   * clear search field
   */
  const clearSearch = () => {
    let search = document && document.getElementById('search-contacts');
    search.value = '';
    searchFilterList("");
  }

  /**
   * render() method to render the WebChatSearch component into browser.
   */
  return (
    <div className="search">
      <input type="text" id="search-contacts" className="search-contacts" name="search-contacts" autoComplete="off"
       placeholder="Search" onChange={(e) => searchFilterList(e.currentTarget.value)}></input>
      <i className={isTyping ? '' : 'Search'} title="Search"> {!isTyping &&  <CustomIcon icon={mf_Search ? mf_Search : <SearchHoc viewBox="0 0 14.201 14.2"/>} {...props} />}</i>
      <i className={isTyping ? 'CloseSearch' : ''} title="Clear search" onClick={() => clearSearch()}>{isTyping && <CustomIcon icon={mf_Close ? mf_Close : <CloseHoc viewBox="0 0 12 12"/> } /> }</i>
    </div>
  );
};

export default WebChatSearch;
